import React from 'react';

import {WidthItem} from 'src/components/width-item';
import {HighlightedText} from 'src/modules/entitlements/components/main-column';
import {GRANT_STATUS_CAPTIONS} from 'src/modules/entitlements/constants';
import {GrantStatus} from 'src/openapi/admin/models/GrantStatus';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';
import Loading from '@pb/kit-component-loading';


import {NO_RESULTS_MESSAGE, UNCLEAR_QUERY_MESSAGE} from './constants';

import type {Grant} from 'src/openapi/admin/models/Grant';
import type {ServerResponse} from 'src/typedef';

type Props = {
    id: string,
    busy: boolean,
    query: string,
    response: ServerResponse<Grant[]> | null,
    selectedGrants: string[],
};

export const AddGrantSuggestResult = ({busy, query, response, id, selectedGrants}: Props) => {
    if (query.length < 2) {
        return (
            <div id={id} className="pd-s">
                {UNCLEAR_QUERY_MESSAGE}
            </div>
        );
    }

    if (busy) {
        return (
            <div id={id} className="pd-s">
                <Group><Loading type="ICON"/> Loading</Group>
            </div>
        );
    }

    if (response?.data?.length) {
        return (
            <div id={id}>
                {response.data.map(grant => (
                    <AutosuggestItem key={grant.id} value={grant.id}>
                        {itemProps => (
                            <Item grow={1}>
                                <Group justify="space-between" alignItems="center">
                                    <Group alignItems="center">
                                        <WidthItem width={200}>
                                            <EllipsisTextHint title={grant.name}>
                                                {itemProps.highlighted ? grant.name : (
                                                    <HighlightedText
                                                        text={grant.name.toLowerCase()}
                                                        highlightedText={query.toLowerCase()}
                                                    />
                                                )}
                                            </EllipsisTextHint>
                                        </WidthItem>
                                        <WidthItem width={70}>
                                            <b>{GRANT_STATUS_CAPTIONS[grant.status as GrantStatus]}</b>
                                        </WidthItem>
                                        {grant.daysToDelay ? (
                                            <WidthItem width={150}>
                                                <EllipsisTextHint title={grant.daysToDelay.toString()}>
                                                    <b>{`DaysToDelay: ${grant.daysToDelay}`}</b>
                                                </EllipsisTextHint>
                                            </WidthItem>
                                        ) : null}
                                    </Group>
                                    {selectedGrants.includes(grant.id) && <Icon type={Icons.CHECK}/>}
                                </Group>
                            </Item>
                        )}
                    </AutosuggestItem>
                ))}
            </div>
        );
    }

    if (response?.data && !response.data.length) {
        return (
            <div id={id} className="pd-s">
                {NO_RESULTS_MESSAGE}
            </div>
        );
    }

    if (response?.error) {
        return (
            <div id={id} className="pd-s">
                {response.error.message}
            </div>
        );
    }

    return null;
};
